import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';

export default class LocationsList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onListItemPressed = this.onListItemPressed.bind(this);
    this.onListItemMouseEnter = this.onListItemMouseEnter.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  }

  onListItemPressed() {
    const { locations, selectedLocationIndex, onListItemClickedOrEntered } = this.props;

    onListItemClickedOrEntered(selectedLocationIndex, locations[selectedLocationIndex]);
  }

  onListItemMouseEnter(e) {
    const { onListItemMouseEnter, locations } = this.props;

    if (!e.currentTarget.dataset.selected) {
      const indexOfListItem = e.currentTarget.dataset.index;

      onListItemMouseEnter(indexOfListItem, locations[indexOfListItem]);
    }
  }

  onKeyDown(e) {
    const currentKey = e.keyCode;
    const {
      locations, selectedLocationIndex,
      onListItemClickedOrEntered, onUpKeyClickWhenListItemSelected,
      onDownKeyClickWhenListItemSelected
    } = this.props;

    if (currentKey === keycode.codes.up || currentKey === keycode.codes.down ||
      currentKey === keycode.codes.enter) {
      e.preventDefault();
    }
    
    switch (currentKey) {
      case keycode.codes.up: {
        const upLocationIndex = ((selectedLocationIndex === 0) ||
        (selectedLocationIndex === -1))
          ? locations.length - 1
          : selectedLocationIndex - 1;

        onUpKeyClickWhenListItemSelected(selectedLocationIndex, upLocationIndex,
          locations[upLocationIndex]);
        break;
      }
      case keycode.codes.down: {
        const downLocationIndex = ((selectedLocationIndex === locations.length - 1) ||
        (selectedLocationIndex === -1))
          ? 0
          : selectedLocationIndex + 1;

        onDownKeyClickWhenListItemSelected(selectedLocationIndex, downLocationIndex,
          locations[downLocationIndex]);

        break;
      }
      case keycode.codes.enter: {
        if (selectedLocationIndex !== -1) {
          onListItemClickedOrEntered(selectedLocationIndex, locations[selectedLocationIndex]);
        }

        break;
      }
      default: {
        break;
      }
    }
  }

  renderItems() {
    return this.props.locations.map((location, i) => {
      const listItemClasses = ['dc-locations-list-item'];

      if (this.props.selectedLocationIndex === i) {
        listItemClasses.push('dc-locations-list-item-selected');
      }
      return (
        <li
          className={listItemClasses.join(' ')}
          key={location.id}
          onMouseDown={this.onListItemPressed}
          onTouchEnd={this.onListItemPressed}
          onMouseEnter={this.onListItemMouseEnter}
          role="option"
          data-index={i}
          aria-selected={(this.props.selectedLocationIndex === i) ? true : undefined}
          data-selected={(this.props.selectedLocationIndex === i) ? true : undefined}
          tabIndex={0}
        >
          <span className="heading-text">
            {location.location}
          </span>

          <span className="subheading-text">
            {`  ${location.description}`}
          </span>

          {location.retailLocation &&
            <span className="icon-container">
              <Icon icon="House" />
            </span>
          }
        </li>
      );
    });
  }

  render() {
    const listClasses = ['dc-locations-list'];

    return (
      <ul
        className={listClasses.join(' ')}
        data-label={this.props.headerLabel}
        role="listbox"
      >
        {this.renderItems()}
      </ul>
    );
  }
}


LocationsList.displayName = 'LocationsList';

LocationsList.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    retailLocation: PropTypes.bool
  })).isRequired,
  selectedLocationIndex: PropTypes.number,
  headerLabel: PropTypes.string,
  onListItemMouseEnter: PropTypes.func,
  onListItemClickedOrEntered: PropTypes.func,
  onUpKeyClickWhenListItemSelected: PropTypes.func,
  onDownKeyClickWhenListItemSelected: PropTypes.func
};

LocationsList.defaultProps = {
  selectedLocationIndex: -1,
  headerLabel: '',
  onListItemMouseEnter: () => {},
  onListItemClickedOrEntered: () => {},
  onUpKeyClickWhenListItemSelected: () => {},
  onDownKeyClickWhenListItemSelected: () => {}
};
